import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props =>
    props.index % 2 === 0 ? props.theme.colors.background.secondary : props.theme.colors.text.inverse};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const PositionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: ${props => props.theme.spacing.sp16};
  border-right: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  margin-right: ${props => props.theme.spacing.sp16};
  min-width: 50px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  flex-grow: 1;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ChipsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`
